module.exports = __webpack_public_path__ + "pendentes.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images2/icons/pendentes.png
 ** module id = 755
 ** module chunks = 0
 **/